<template>
    <modal dialog="modal-lg" class="dark-top" :header="false" :customClass="'heightAuto'" :footer="true">
        <div slot="body" class="p-4">

            <h2 class="text-center mb-3">{{`Duplicate Product ${originalProduct.name}`}}</h2>

            <p class="mb-3">
                Please the new product name
            </p>


            <div class="form-group row">
                <div class="col-sm-12">

                    <input v-if="isDuplicatingProduct == false && newDuplicatedProduct !=null" type="text" class="w-100" v-model="newDuplicatedProduct.name">

                    <div v-else class="w-100 text-center">
                        <loader />
                    </div>
                </div>
            </div>

            <!-- <div class="mb-1">
                <checkbox v-model="duplicateSchedules">
                    <span>Include schedules</span>
                    <i class="fas fa-info-circle dark ml-1" v-tooltip="'If checked the new product will include the original product present and future schedules'"></i>
                </checkbox>
            </div> -->

        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="pressDuplicate" :disabled="isInvalidValid">Duplicate</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Loader from '@/tools/loaders/loader1'
    import Modal from './Modal'

    export default {
        created: function () {
            this.newDuplicatedProduct = JSON.parse(JSON.stringify(this.getSelectedItem))
        },
        data: function() {
            return {
                newDuplicatedProduct: null,
                isDuplicatingProduct: false,
                duplicateSchedules: false,
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedItem'
            ]),
            originalProduct: function () {
                return this.getSelectedItem
            },
            isInvalidValid: function () {
                return !this.newDuplicatedProduct.name || this.newDuplicatedProduct.name == "" || this.newDuplicatedProduct.name == null
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'duplicateProduct',
                'initProducts'
            ]),
            cancel: function() {
                this.closeModal();
            },
            pressDuplicate: function() {
                this.isDuplicatingProduct = true
                this.duplicateProduct({
                    product: this.newDuplicatedProduct,
                }).then(response => {
                    this.isDuplicatingProduct = false
                    if(response != false){
                        this.initProducts()
                        this.closeModal();
                    }
                })
            }
        },
        components: {
            Modal,
            Loader
        }
    }
</script>



// WEBPACK FOOTER //
// ProductDuplicate.vue?7e18fecc